import './dot.scss';

const Dot = (props: { active: boolean }) => {
    const dotClass = props.active ? "dot dot-secondary" : "dot dot-primary";
    return (
        <div className={dotClass}></div>
    )
}

export default Dot